import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Tooltip, Space } from "antd";
import { CheckCircleOutlined, UsergroupAddOutlined, ApartmentOutlined } from "@ant-design/icons";
import { TableCustom } from "../../../components/table";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";

export const ProblemasPerfisVisualizacao = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    listarColaboradores();
  }, []);

  // LISTAR COLABORADORES
  const listarColaboradores = async () => {
    setLoading(true);
    const api = await http("get", `v1/usuario/lista_colaboradores`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "matricula",
      title: "Matrícula",
      sorter: (a, b) => a.matricula?.toString()?.localeCompare(b.matricula?.toString()),
    },
    {
      title: "Colaborador",
      dataIndex: "nome",
      sorter: (a, b) => a.nome?.localeCompare(b.nome),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 100,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Setores">
            <Button
              loading={loading}
              onClick={() => navigate(`/planos-acao/perfis/setores/${e.id}`)}
              icon={<CheckCircleOutlined />}
            />
          </Tooltip>
          <Tooltip title="Grupo Origem">
            <Button
              loading={loading}
              onClick={() => navigate(`/planos-acao/perfis/sistemas-origem/${e.id}`)}
              icon={<ApartmentOutlined />}
            />
          </Tooltip>
        </Space.Compact>
      ),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Planos de Ação" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Planos de Acão Perfis"
              subtitle="Liberar acessos colaboradores"
              icon={<UsergroupAddOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom columns={columns} dataSource={dados} loading={loading} />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
